import { GiCommercialAirplane } from "react-icons/gi";
import * as ReactSelect from "react-select";
import AsyncSelect from "react-select/async";
import Loader from "../../util/Loader";
import { baseUrl } from "../../store/airport/apis";
import { useEffect, useState } from "react";
import { buildSelectStyles } from "./selectStyles";
const { components } = ReactSelect;
// Example function to simulate fetching data from an API
const fetchUsers = async (inputValue: any) => {
  if (inputValue && inputValue.length > 2) {
    const response = await fetch(
      `${baseUrl}/flights/airports?q=${inputValue}`
    );
    const data = await response.json();
    return sortByName(data);
  }
};
function sortByName(arr: any) {
  return arr.sort((a: any, b: any) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
}
const BasicAirportSearchInput = ({
  name,
  onChange,
  placeholder,
  value,
  pos = "left",
  initialSearch,
  onInputValueChange,
  variant = "light",
}: any) => {
  const [inputValue, setInputValue] = useState(initialSearch);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const dark = variant === "dark";

  const customStyles = buildSelectStyles({ dark, pos });

  const loadOptions = (inputValue: any) => {
    return fetchUsers(inputValue);
  };

  useEffect(() => {
    if (initialSearch) {
      loadOptions(initialSearch).then((options) => {
        setDefaultOptions(options);
        onChange(options[0]);
      });
    }
  }, [initialSearch]);
  const CustomOption = (props: any) => {
    return (
      <components.Option {...props}>
        <div className=" font-semibold  capitalize cursor-pointer hover:bg-slate-100 ">
          <div className="flex items-center space-x-4">
            <div className="text-lg">
              <GiCommercialAirplane />
            </div>
            <div className="text-sm ">
              <div className="p-0 m-0">
                {props.data.name}
                <span>{` (${props.data.code})`}</span>
              </div>
              <p className="text-[10px] font-light capitalize p-0 m-0">{`${props.data.region}, ${props.data.country}`}</p>
            </div>
          </div>
        </div>
      </components.Option>
    );
  };

  const CustomLoader = (props: any) => {
    return (
      <components.LoadingIndicator {...props}>
        <Loader />
      </components.LoadingIndicator>
    );
  };
  const CustomNoOptionsMessage = (props: any) => (
    <components.NoOptionsMessage {...props}>
      {/* Custom message or JSX can go here */}
      <span style={{ fontStyle: "italic", color: "#999" }}>
        No results found. Try another search!
      </span>
    </components.NoOptionsMessage>
  );
  return (
    <div
      className={
        dark
          ? "border-white/25 bg-white/10 outline-none flex flex-col border-[1px] py-1 h-14 rounded-[14px] w-full text-white px-3 focus-within:border-orange-400 transition-colors"
          : "border-[#302D6340] bg-white  outline-none flex flex-col border-[1px] py-1 h-14 rounded-[4px] w-full text-[#171717] px-3  focus:border-b-[#EE723A] focus:border-2"
      }
    >
      <label className={dark ? "text-xs text-white/55" : "text-xs text-slate-500"}>{name}</label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadOptions}
        components={{
          Option: CustomOption,
          LoadingIndicator: CustomLoader,
          DropdownIndicator: () => null,
          NoOptionsMessage: CustomNoOptionsMessage,
        }}
        placeholder={placeholder}
        styles={customStyles}
        onChange={onChange}
        value={value}
        defaultOptions={defaultOptions}
        menuPlacement="auto"
        getOptionLabel={(option: any) => option.name}
        getOptionValue={(option: any) => option}
        onInputChange={(value) => {
          setInputValue(value);
          if (onInputValueChange) {
            onInputValueChange(value);
          }
          return value;
        }}
        inputValue={inputValue}
        isClearable
        //  isMulti
      />
    </div>
  );
};

export default BasicAirportSearchInput;
